import Vue from 'vue'
import router from '@/router'
import store from '@/store/'
import { ACCESS_TOKEN } from "@/store/mutation-types";
import HomeLayout from './layouts/HomeLayout'
import CmsLayout from './layouts/CmsLayout'
import UserLayout from './layouts/UserLayout'
import BlankLayout from '@/components/layouts/BlankLayout'

const whiteList = ['/login', '/home', '/cms', '/cert/query'] // no redirect whitelist

router.beforeEach((to, from, next) => {
  if (Vue.ls.get(ACCESS_TOKEN)) {
      next()
  } else {
    if (whiteList.indexOf(to.path) == -1) {
      next()
      // next({ path: '/user/login', query: { redirect: to.fullPath } })
    }else{
      next()
    }
  }
})
let tenantConfig = store.getters.tenantInfo
/**
 * 基础路由
 * @type { *[] }
 */
const RouterMap = [
  
  {
    path: '/',
    component: HomeLayout,
    redirect: location.host=='edu.aipj.org.cn' ? '/index3': (tenantConfig && tenantConfig.home || '/index'),
    hidden: true,
    children: [
      {
        path: '/index3',
        name: 'home3',
        component: () => import(/* webpackChunkName: "aipj" */ './views/Home3')
      },
    ]
  },
  {
    path: '/',
    component: CmsLayout,
    redirect: '/index',
    hidden: true,
    children: [
      {
        path: '/school',
        name: 'school',
        component: () => import(/* webpackChunkName: "aipj" */ './views/School')
      },
      {
        path: '/join',
        name: 'join',
        component: () => import(/* webpackChunkName: "aipj" */ './views/Join')
      },
      {
        path: '/index',
        name: 'home',
        component: () => import(/* webpackChunkName: "aipj" */ './views/Home')
      },
      {
        path: '/index2',
        name: 'home2',
        component: () => import(/* webpackChunkName: "aipj" */ './views/Home2')
      },
      {
        path: '/login',
        name: 'login',
        component:() => import(/* webpackChunkName: "aipj" */ './views/user/Login')
      },
      {
        path: '/register',
        name: 'register',
        component:() => import(/* webpackChunkName: "aipj" */ './views/user/Register')
      },
      {
        path: '/find',
        name: 'find',
        component:()=>import(/* webpackChunkName: "aipj" */ './views/user/Find')
      }
    ]
  },
  // >>>>>qceit
  {
    path: '/production',
    name: 'production',
    redirect: '/production/index',
    component: HomeLayout,
    children: [
      {
        path: 'index',
        name: 'productIndex',
        component: () => import(/* webpackChunkName: "aipj" */ './views/ProductList')
      },
      {
        path: 'detail',
        name: 'productDetail',
        component: () => import(/* webpackChunkName: "aipj" */ './views/ProductDetail')
      },
    ]
  },
  {
    path: '/course',
    name: 'course',
    redirect: '/course/index',
    component: HomeLayout,
    children: [
      {
        path: 'index',
        name: 'courseIndex',
        component: () => import(/* webpackChunkName: "aipj" */ './views/CourseList')
      },
      {
        path: 'detail',
        name: 'courseDetail',
        component: () => import(/* webpackChunkName: "aipj" */ './views/CourseDetail')
      },
    ]
  },
  {
    path: '/contest',
    name: 'contest',
    redirect: '/contest/index',
    component: HomeLayout,
    children: [
      {
        path: 'index',
        name: 'contestIndex',
        component: () => import(/* webpackChunkName: "aipj" */ './views/ContestList')
      },
      {
        path: 'detail',
        name: 'contestDetail',
        component: () => import(/* webpackChunkName: "aipj" */ './views/ContestDetail')
      },
    ]
  },
  {
    path: '/paper',
    name: 'paper',
    redirect: '/paper/index',
    component: HomeLayout,
    children: [
      {
        path: 'index',
        name: 'paperIndex',
        component: () => import(/* webpackChunkName: "aipj" */ './views/PaperList')
      },
    ]
  },
  // >>>>>qceit
  {
    path: '/examine',
    component:()=>import(/* webpackChunkName: "aipj" */ '@/components/exam/Examine')
  },
  {
    path: '/cert',
    component: BlankLayout,
    redirect: '/cert/query',
    hidden: true,
    children: [
      {
        path: '/cert/query',
        name: 'certQuery',
        component: () => import(/* webpackChunkName: "aipj" */ './views/CertQuery')
      },
      // {
      //   path: '/cert/score',
      //   name: 'scoreQuery',
      //   component: () => import(/* webpackChunkName: "aipj" */ './views/ScoreQuery')
      // },
      {
        path: '/cert/studentReport',
        name: 'studentReport',
        component: () => import(/* webpackChunkName: "aipj" */ './views/StudentCategoryReport')
      }
    ]
  },
  {
    path: '/user',
    component: UserLayout,
    redirect: '/user/event',
    children: [
      {
        path: 'event',
        name: 'userEvent',
        component: () => import(/* webpackChunkName: "aipj" */ './views/user/Event')
      },
      {
        path: 'order',
        name: 'userOrder',
        component: () => import(/* webpackChunkName: "aipj" */ './views/user/Order')
      },
      {
        path: 'info',
        name: 'userInfo',
        component: () => import(/* webpackChunkName: "aipj" */ './views/user/Info')
      },
      {
        path: 'cert',
        name: 'userCert',
        component: () => import(/* webpackChunkName: "aipj" */ './views/user/Cert')
      },
      {
        path: 'score',
        name: 'userScore',
        component: () => import(/* webpackChunkName: "aipj" */ './views/user/Score')
      },
      {
        path: 'setting',
        name: 'userSetting',
        component: () => import(/* webpackChunkName: "aipj" */ './views/user/Setting')
      },
      {
        path: 'work',
        name: 'userWork',
        component: () => import(/* webpackChunkName: "aipj" */ './views/user/Work')
      },
      {
        path: 'question',
        name: 'userQuestion',
        component: () => import(/* webpackChunkName: "aipj" */ './views/user/Question')
      },
      {
        path: 'myPaper',
        name: 'myPaper',
        component: () => import(/* webpackChunkName: "aipj" */ './views/user/MyPaper')
      },
      {
        path: 'myPaperAnswer',
        name: 'myPaperAnswer',
        component: () => import(/* webpackChunkName: "aipj" */ './views/user/MyPaperAnswer')
      },
      {
        path: 'userPaper',
        name: 'userPaper',
        component: () => import(/* webpackChunkName: "aipj" */ '@/components/exam/UserPaperPreview')
      },
    ]
  },
  {
    path: '/event',
    name: 'event',
    redirect: '/event/cate',
    component: CmsLayout,
    children:[
      {
        path: 'cate',
        name: 'eventCategory',
        component: () => import(/* webpackChunkName: "aipj" */ './views/EventCategory')
      },
      {
        path: 'list',
        name: 'eventList',
        component: () => import(/* webpackChunkName: "aipj" */ './views/EventList')
      },
      {
        path: 'detail',
        name: 'eventDetail',
        component: () => import(/* webpackChunkName: "aipj" */ './views/EventDetail')
      },
      {
        path: 'apply',
        name: 'eventApply',
        component: () => import(/* webpackChunkName: "aipj" */ './views/EventApply')
      },
      {
        path: 'desc',
        name: 'eventDesc',
        component: () => import(/* webpackChunkName: "aipj" */ './views/EventDesc')
      },
      {
        path: 'workList',
        name: 'workList',
        component: () => import(/* webpackChunkName: "aipj" */ './views/WorkList')
      },
      {
        path: 'workDetail',
        name: 'workDetail',
        component: () => import(/* webpackChunkName: "aipj" */ './views/WorkDetail')
      },
    ]
  },
  {
    path: '/activity',
    name: 'activity',
    redirect: '/activity/list',
    component: CmsLayout,
    children:[
      {
        path: 'list',
        name: 'activityList',
        component: () => import(/* webpackChunkName: "aipj" */ './views/ActivityList')
      },
      {
        path: 'detail',
        name: 'activityDetail',
        component: () => import(/* webpackChunkName: "aipj" */ './views/ActivityDetail')
      },
    ]
  },
  {
    path: '/cms',
    name: 'cms',
    redirect: '/cms/list',
    component: CmsLayout,
    children: [
      {
        path: 'list',
        name: 'cmsList',
        component: () => import(/* webpackChunkName: "aipj" */ './views/CmsList')
      },
      {
        path: 'preview',
        name: 'cmsPreview',
        component: ()=> import(/* webpackChunkName: "aipj" */ './views/CmsPreviewList')
      },
      {
        path: 'detail',
        name: 'cmsDetail',
        component: () => import(/* webpackChunkName: "aipj" */ './views/CmsDetail')
      },
      {
        path: 'video',
        name: 'cmsVideo',
        component: () => import(/* webpackChunkName: "aipj" */'./views/VideoList')
      },
      {
        path: 'pic',
        name: 'cmsPic',
        component: () => import(/* webpackChunkName: "aipj" */'./views/PicList')
      },
    ]
  },

]
export default RouterMap